<script setup>
import closeWhiteKiosk from "assets/graphics/icons/cd-close-white-kiosk.svg";
import closeWhite from "assets/graphics/icons/cd-close-white.svg";
import close from "assets/graphics/icons/cd-close.svg";
import home from "assets/graphics/icons/cd-home.svg";
import leftKiosk from "assets/graphics/icons/cd-left-kiosk.svg";
import left from "assets/graphics/icons/cd-left.svg";
import mobile from "assets/graphics/icons/cd-mobile.svg";
import pencil from "assets/graphics/icons/cd-pen-white.svg";
import phone from "assets/graphics/icons/cd-phone.svg";
import plusDark from "assets/graphics/icons/cd-plus-dark.svg";
import plus from "assets/graphics/icons/cd-plus.svg";
import rightKiosk from "assets/graphics/icons/cd-right-kiosk.svg";
import right from "assets/graphics/icons/cd-right.svg";
import zoomCircle from "assets/graphics/icons/cd-search-circle.svg";
import zoom from "assets/graphics/icons/cd-search-plus.svg";
import search from "assets/graphics/icons/cd-search.svg";
import trash from "assets/graphics/icons/cd-trash-white.svg";

const props = defineProps({
  name: {
    type: String,
    required: true
  }
});

const icon = computed(() => {
  switch (props.name) {
    case "pencil":
      return pencil;
    case "trash":
      return trash;
    case "close":
      return close;
    case "closeWhite":
      return closeWhite;
    case "left":
      return left;
    case "right":
      return right;
    case "phone":
      return phone;
    case "home":
      return home;
    case "mobile":
      return mobile;
    case "plus":
      return plus;
    case "plusDark":
      return plusDark;
    case "search":
      return search;
    case "zoom":
      return zoom;
    case "zoomCircle":
      return zoomCircle;
    case "leftKiosk":
      return leftKiosk;
    case "rightKiosk":
      return rightKiosk;
    case "closeWhiteKiosk":
      return closeWhiteKiosk;
    default:
      return right;
  }
});
</script>

<template>
  <img :src="icon" :alt="props.name">
</template>

<style scoped>

</style>
